import ButtonTypes from './buttonTypes';

const warehousePartsStatus = {
  IN_STOCK: 'In stock',
  OUT_OF_STOCK: 'Out of stock',
  ARCHIVED: 'Archived',
  DISCONTINUED: 'Discontinued',
};

const warehousePartsNeededStatus = {
  OK: 'Ok',
  NEED_ORDER: 'Need order',
};

export const warehouseStatusInfo = {
  [warehousePartsStatus.IN_STOCK]: {
    title: 'In stock',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [warehousePartsStatus.OUT_OF_STOCK]: {
    title: 'Out of stock',
    state: ButtonTypes.LIGHT_DANGER
  },
  [warehousePartsStatus.ARCHIVED]: {
    title: 'Archived',
    state: ButtonTypes.DARK
  },
  [warehousePartsStatus.DISCONTINUED]: {
    title: 'Discontinued',
    state: ButtonTypes.DARK
  },
};

export const warehousePartsNeededInfo = {
  [warehousePartsNeededStatus.OK]: {
    title: 'OK',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [warehousePartsNeededStatus.NEED_ORDER]: {
    title: 'Need order',
    state: ButtonTypes.LIGHT_DANGER
  },
};

export const warehouseStatusList = [
  { label: warehousePartsStatus.IN_STOCK, value: warehousePartsStatus.IN_STOCK },
  { label: warehousePartsStatus.OUT_OF_STOCK, value: warehousePartsStatus.OUT_OF_STOCK },
  { label: warehousePartsStatus.ARCHIVED, value: warehousePartsStatus.ARCHIVED },
  { label: warehousePartsStatus.DISCONTINUED, value: warehousePartsStatus.DISCONTINUED },
];

export const warehousePartsNeededList = [
  { label: warehousePartsNeededStatus.OK, value: warehousePartsNeededStatus.OK },
  { label: warehousePartsNeededStatus.NEED_ORDER, value: warehousePartsNeededStatus.NEED_ORDER },
];
export default warehousePartsStatus;
